export const trackingCode = {
  look_statisticks: 'look_statisticks',
  open_add_campaign: 'open_add_campaign',
  open_delete_campaign: 'open_delete_campaign',
  delete_campaign: 'delete_campaign',
  cancel_delete_campaign: 'cancel_delete_campaign',
  deleted_campaigns: 'deleted_campaigns',
  reestablish_campaign: 'reestablish_campaign',
  close_deleted_campaigns: 'close_deleted_campaigns',
  open_add_article: 'open_add_article',
  close_add_article: 'close_add_article',
  search_url_article: 'search_url_article',
  clear_url_article: 'clear_url_article',
  add_article: 'add_article',
  deleted_articles: 'deleted_articles',
  open_delete_article: 'open_delete_article',
  close_deleted_articles: 'close_deleted_articles',
  reestablish_article: 'reestablish_article',
  cancel_delete_article: 'cancel_delete_article',
  delete_article: 'delete_article',
  open_ratio: 'open_ratio',
  close_ratio: 'close_ratio',
  check_text: 'check_text',
  show_all_articles: 'show_all_articles',

  search_url_campaign: 'search_url_campaign',
  clear_search_campaign: 'clear_search_campaign',
  search_text_campaign: 'search_text_campaign',
  save_text_campaign: 'save_text_campaign',
  cancel_add_campaign: 'cancel_add_campaign',
  open_edit_campaign: 'open_edit_campaign',
  cancel_edit_campaign: 'cancel_edit_campaign',
  save_edit_campaign: 'save_edit_campaign',
  create_campaign: 'create_campaign',

  search_url_first_campaign: 'search_url_first_campaign',
  clear_search_first_campaign: 'clear_search_first_campaign',
  search_text_first_campaign: 'search_text_first_campaign',
  save_text_first_campaign: 'save_text_first_campaign',
  cancel_add_first_campaign: 'cancel_add_first_campaign',
  open_edit_first_campaign: 'open_edit_first_campaign',
  cancel_edit_first_campaign: 'cancel_edit_first_campaign',
  save_edit_first_campaign: 'save_edit_first_campaign',

  create_first_campaign: 'create_first_campaign',

  open_delete_group: 'open_delete_group',
  cancel_delete_group: 'cancel_delete_group',
  delete_group: 'delete_group',
  cancel_receive_notif: 'cancel_receive_notif',
  open_receive_notif: 'open_receive_notif',
  receive_notif_on: 'receive_notif_on',
  receive_notif_off: 'receive_notif_off',
  link_to_group: 'link_to_group',
  link_to_favorite: 'link_to_favorite',
  show_all_groups: 'show_all_groups',
  download_html: 'download_html',
  download_xls: 'download_xls',
  copy_link: 'copy_link',
  open_add_first_campaign: 'open_add_first_campaign',
  go_to_group: 'go_to_group',
  user_logout: 'user_logout',
  user_login: 'user_login',

  download_chart: 'download_chart',
  resetablish_group: 'resetablish_group',
  deleted_groups: 'deleted_groups',
  forgot_pass: 'forgot_pass',
  send_link_pass: 'send_link_pass',
  cancel_reset_pass: 'cancel_reset_pass',
  save_new_pass: 'save_new_pass',

  user_setting: 'user_setting',
  auth_setting: 'auth_setting',
  personal_setting: 'personal_setting',
  cancel_setting: 'cancel_setting',
  save_setting: 'save_setting',

  open_rename_campaign_option: 'open_rename_campaign_option',
  close_rename_campaign_option: 'close_rename_campaign_option',
  save_rename_campaign_option: 'save_rename_campaign_option',
  clear_trash: 'clear_trash',

  open_trial_modal: 'open_trial_modal',
  close_trial_modal: 'close_trial_modal',
  trial_ok: 'trial_ok',
  copy_link_article: 'copy_link_article'
};
